var Foundation = (function () {

    var self = {};

    const svg4everybody = require ('./../../../../build/node_modules/@components/svg4everybody/dist/svg4everybody.min.js');
    const inlineSVG = require ('./../../../../build/node_modules/@components/inline-svg/src/inlineSVG.js');

    self.init = function () {

        App.Globals.$document.foundation();

        //  Internet Explorer SVG
        svg4everybody();

        //  SVG Inline
        inlineSVG.init({
            svgSelector: 'img.svg',
            initClass: 'js-inlinesvg'
        });

    };

    return self;

}());

module.exports = Foundation;